import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  Tooltip
} from '@mui/material';
import { GridFooter, GridFooterContainer, GridLinkOperator } from '@mui/x-data-grid-pro';
import axios from 'axios';
import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import config from 'src/appConfig';
import { AppState, store } from 'src/store';
import { useAppSelector } from 'src/store/hooks';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { DataGridComponent } from '../common/DataGridComponent';
import { GridComponent } from '../common/GridComponent';
import { PopupComponent } from '../common/PopupComponent';
//import { SearchHierarchy } from '../common/hierarchy/SearchHierarchy';
import { TreeViewComponent } from '../common/treeview/TreeViewComponent';
import { DocumentUpload } from '../eTMF/documentUpload/DocumentUpload';
import DocManagementService from '../eTMF/documentUpload/service/DocManagementService';
import AuditHistory from '../eTMF/documentViewer/AuditHistory';
import DocumentViewerComponent from '../eTMF/documentViewer/DocumentViewer';
import VersionHistory from '../eTMF/documentViewer/VersionHistory';
import SendasLink from '../eTMF/modelViewer/SendasLink';
import SearchHierarchy from '../layouts/DashboardLayout/SearchHierarchy';
import { CustomToolbar } from './CustomToolBar';
import { RecentDocuments } from './RecentDocuments';
import { useColumns } from './useColumns';
import { useViewer } from './useViewer';
import { CustomPagination } from 'src/util/DataTableFooter';
import newconfig from '../../appConfig';
import { hideLoader, showLoader } from 'src/store/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../common/Loader';
export interface IViewer {
  routeInfo?: (route: string) => void;
  onClicked?: boolean;
}

export const Viewer: React.FC<IViewer> = props => {
  const {
    expanded,
    toggle,
    binderViewTitle,
    treeItemClick,
    treeViewData,
    recentDocumentClick,
    recentDocuments,
    recentDocumentsHeading,
    apiRef,
    documents,
    pageSize,
    setPageSize,
    columnVisibilityModel,
    setColumnVisibilityModel,
    getLoadingState,
    getSelectedData,
    items,
    documentToDisplay,
    dataGridComponent,
    gethashedurikey,
    onGridLinkClick,
    handleClick,
    anchorEl,
    handleClose,
    openAuditTrail,
    setOpenAuditTrail,
    setAnchorEl,
    openSendAsLinkDialog,
    setOpenVersionHistory,
    openVersionHistory,
    setSendAsLinkDialog,
    fileId,
    setFileId,
    setDocumentToDisplay,
    setDataGridComponent,
    artifactList,
    selectedRowDocumentDetails,
    getRecentDocs,
    docUploadComponent,
    setDocUploadComponent,
    checkPermission,
    menu,
    getAllDoc,
    pageNumber,
    setPageNumber,
    rowCount
  } = useViewer(props);

  const { columns } = useColumns({
    anchorEl,
    artifactList,
    gethashedurikey,
    handleClick,
    handleClose,
    onGridLinkClick
  });

  const setSearchData = (study: string, country: string, site: string) => {
    getSelectedData({
      sponsor: 'PiHealth',
      study: study === '--' ? '--' : study,
      country: country === '--' ? '--' : country,
      site: site === '--' ? '--' : site
    });
  };
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  const [displayDoc, setDisplayDoc] = useState<boolean>(false);
  const docService = new DocManagementService();

  useEffect(() => {
    getRecentDocs();
  }, [displayDoc]);

  // for Send to TMF Dialog
  const [openSend, setOpenSend] = React.useState(false);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [noOfRows, setNoOfRows] = useState<any>([]);
  const [checked, setChecked] = useState<boolean>(false);
  const [allNewFiles, setAllNewFiles] = useState([]);
  const [isfToBePublishedFiles, setIsfToBePublishedFiles] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [overwrite, setOverwrite] = useState<boolean>(false);
  const [isEnable, setIsEnable] = useState<boolean>(true);
  const [loadingSendToTMF, setLoadingSendToTMF] = useState<boolean>(false);
  const isfInstance = axios.create({ baseURL: `${newconfig.appConfig.apiisf}` });
  const dispatch = useDispatch();
  const isLoaderLoading: any = useSelector((state: AppState) => state.loader.isLoading);
  const [loaderStatus, setLoaderStatus] = useState(isLoaderLoading);
  useEffect(() => {
    setLoaderStatus(isLoaderLoading);
  }, [isLoaderLoading]);
  const filterFiles = async () => {
    dispatch(showLoader());
    if (selectedFiles.length > 0) {
      const tempNewFiles: any = [];
      selectedFiles.forEach((file: any) => {
        if (file.sent_to_tmf === false) {
          tempNewFiles.push(file);
        }
      });
      const newVersionFiles: any = [];
      const overwriteOrNewVersionFiles: any = [];
      if (tempNewFiles.length > 0) {
        const payload = { isf_document_ids: tempNewFiles.map((file: any) => file.isf_document_id) };
        const resp: any = await docService.VersionBasedDocuments(payload);
        if (resp.data && resp.data.length > 0) {
          tempNewFiles.forEach((file: any) => {
            if (resp.data.find((resFile: any) => resFile.isf_document_id === file.isf_document_id)) {
              overwriteOrNewVersionFiles.push(file);
            } else {
              newVersionFiles.push(file);
            }
          });
          setAllNewFiles(newVersionFiles);
        } else {
          setAllNewFiles(tempNewFiles);
        }
        setIsfToBePublishedFiles(overwriteOrNewVersionFiles);
      }
      if (overwriteOrNewVersionFiles.length === 0 && (newVersionFiles.length > 0 || tempNewFiles.length > 0)) {
        const fileIds = (newVersionFiles.length > 0 ? newVersionFiles : tempNewFiles)
          .filter((item: any) => item)
          .map((item: any) => item.id);
        const data = { doucment_id: [...fileIds] };
        const response = await docService.BulkUpload(false, 'ISF Binder Viewer', data);
        if (response.data) {
          if (response.data.doucment_id?.length > 0) {
            store.dispatch(setSnackbarMessage('Document(s) sent to TMF successfully.', 'success'));
            getAllDoc();
            onSelectionModelChange([]);
          } else {
            store.dispatch(
              setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error')
            );
          }
        } else {
          store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
        }
      } else if (newVersionFiles.length === 0 && tempNewFiles.length === 0) {
        store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
      } else {
        setOpenSend(true);
      }
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
    }
    setLoadingSendToTMF(false);
    dispatch(hideLoader());
  };
  const handleRadioValue = (e: any, value: any) => {
    setChecked(true);
    if (value === 'newVersion') {
      setOverwrite(false);
    } else {
      setOverwrite(true);
    }
  };
  const handleClickOpenSend = () => {
    if (noOfRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to be sent to TMF at once', 'error'));
    } else {
      setLoadingSendToTMF(true);
      filterFiles();
    }
  };
  const handleCloseSend = async () => {
    dispatch(showLoader());
    let response1: any = [];
    let response2: any = [];
    if (isfToBePublishedFiles.length > 0) {
      if (overwrite) {
        response1 = await docService.BulkUpload(true, 'ISF Binder Viewer', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      } else {
        response1 = await docService.BulkUpload(false, 'ISF Binder Viewer', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      }
    }
    if (allNewFiles.length > 0) {
      response2 = await docService.BulkUpload(false, 'ISF Binder Viewer', {
        doucment_id: allNewFiles.map((file: any) => file.id)
      });
    }
    if (response1?.data || response2?.data) {
      if (response1.data.doucment_id?.length > 0 || response2.data.doucment_id?.length > 0) {
        store.dispatch(setSnackbarMessage('Document(s) sent to TMF successfully.', 'success'));
        getAllDoc();
        onSelectionModelChange([]);
      } else {
        store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
      }
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
    }
    setOpenSend(false);
    dispatch(hideLoader());
  };

  const handleClosePopup = () => {
    setOpenSend(false);
  };

  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const filesSelected: any = items
      .filter((row: any) => selectedIds.has(row.id))
      .filter(
        (elem: any) =>
          elem.isf_doc_status === 'Approved' &&
          elem.need_sent_to_tmf === 'Yes' &&
          elem.isf_doc_viewer_ref_model_version.slice(0, 3) === 'ISF' &&
          (elem.isf_doc_viewer_includes_phi === false ||
            (elem.isf_doc_viewer_includes_phi === true && elem.isf_doc_viewer_doc_phi_redacted === 'Y')) &&
          elem.isf_doc_version_number % 1 === 0
      );

    setSelectedFiles(filesSelected);
    const rowSelected = items.filter((row: any) => selectedIds.has(row.id)).map(elem => elem.fileId);
    setNoOfRows(rowSelected);
    setSelectedRows(rowSelected);
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setIsEnable(false);
    } else {
      setIsEnable(true);
    }
  }, [selectedRows]);

  const url = `${config.appConfig.apiisf}/fileMaster/downloadFiles?country_id=${menu.country}&site_id=${menu.site}&study_id=${menu.study}&isf_doc_level=Site&application=ISF&module_section_related=ISF%20Binder%20Viewer&log=Y&original=N&bulk_download=true`;
  const payload: any = {
    id: selectedRows
  };

  const handleBulkDownload = (url: any) => {
    const newState = store.getState();
    const axiosOptions: any = {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    if (selectedRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to download at once', 'error'));
    } else {
      setLoading(true);
      isfInstance
        .post(url, payload, axiosOptions)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          const filename = 'ISF_Binder_Viewer_Bulk_Download.zip';
          saveAs(blob, filename);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  };

  if (loading)
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme: { zIndex: { drawer: number } }) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress />
        </Backdrop>
      </>
    );

  // for Custom buttons at Data Grid
  function CustomFooterButtons() {
    return (
      <GridFooterContainer>
        <Box sx={{ p: 1, display: 'flex', columnGap: 1 }} className="customFtBtnWrap">
          {checkPermission('bulk_download') && (
            <Button variant="outlined" onClick={() => handleBulkDownload(url)} disabled={isEnable}>
              Download
            </Button>
          )}
          <Tooltip
            placement="top"
            title="Only documents configured to be sent to TMF in 'Planning' and those in 'Approved' status will be sent to TMF"
          >
            <Button
              variant="outlined"
              onClick={handleClickOpenSend}
              className={checkPermission('send_to_tmf') ? '' : 'hide'}
              disabled={noOfRows.length <= 0 || loadingSendToTMF}
              sx={{ minWidth: 112 }}
            >
              Send to TMF
            </Button>
          </Tooltip>
        </Box>

        <GridFooter />
      </GridFooterContainer>
    );
  }
  return (
    <React.Fragment>
      {dataGridComponent ? (
        <React.Fragment>
          {docUploadComponent ? (
            <div>
              <div>
                <SearchHierarchy searchData={setSearchData} />
                {/* <SearchHierarchy getLoadingState={getLoadingState} getSelectedData={getSelectedData}></SearchHierarchy> */}
                {isDataAvailable != null && isDataAvailable === false ? (
                  <div className="no-data-class">
                    <h3>No Data access available!</h3>
                  </div>
                ) : (
                  <>
                    <GridComponent container className="model-viewer-page">
                      <GridComponent md={12}>
                        <GridComponent container>
                          <GridComponent md={4} xl={3}>
                            <h4>{binderViewTitle}</h4>
                            <TreeViewComponent
                              expanded={expanded}
                              toggle={toggle}
                              treeitemclick={treeItemClick}
                              treeViewData={treeViewData}
                            ></TreeViewComponent>
                          </GridComponent>
                          <GridComponent md={8} xl={9}>
                            <RecentDocuments
                              handleClick={recentDocumentClick}
                              items={recentDocuments}
                              heading={recentDocumentsHeading}
                            ></RecentDocuments>
                            <div
                              className="tmf-binder-viewer"
                              style={{ minHeight: '59vh', height: 'calc(100% - 100px)', width: '100%' }}
                            >
                              <DataGridComponent
                                apiRef={apiRef}
                                rows={items}
                                columns={columns}
                                checkboxSelection
                                selectionModel={selectionModel}
                                disableSelectionOnClick={selectedRows && selectedRows.length > 10 ? true : false}
                                onSelectionModelChange={onSelectionModelChange}
                                checkboxSelectionVisibleOnly={true}
                                page={pageNumber}
                                onPageChange={newPage => setPageNumber(newPage)}
                                rowCount={rowCount}
                                pageSize={pageSize}
                                onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                disableColumnSelector={false}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterButtons,
                                  Pagination: CustomPagination
                                }}
                                // initialState={{
                                //   sorting: {
                                //     sortModel: [{ field: 'isf_document_name', sort: 'asc' }]
                                //   }
                                // }}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel: any) => {
                                  setColumnVisibilityModel(newModel);
                                }}
                                componentsProps={{
                                  filterPanel: {
                                    linkOperators: [GridLinkOperator.And, GridLinkOperator.Or],
                                    items: [
                                      { id: 1, columnField: 'isf_doc_version_number', operatorValue: '>', value: '' }
                                    ]
                                  }
                                }}
                                className="Binder_DataGrid"
                                // hideFooterSelectedRowCount={true}
                              />
                            </div>
                          </GridComponent>
                        </GridComponent>
                      </GridComponent>
                    </GridComponent>
                  </>
                )}
              </div>
              {openAuditTrail && (
                <AuditHistory
                  openAuditTrail={openAuditTrail}
                  setOpenAuditTrail={setOpenAuditTrail}
                  setAnchorEl={setAnchorEl}
                  setFileId={setFileId}
                />
              )}
              {openVersionHistory && (
                <VersionHistory
                  openVersionHistory={openVersionHistory}
                  setOpenVersionHistory={setOpenVersionHistory}
                  setAnchorEl={setAnchorEl}
                  setFileId={setFileId}
                  dataGridComponent={dataGridComponent}
                  setDataGridComponent={setDataGridComponent}
                  setDocumentToDisplay1={setDocumentToDisplay}
                />
              )}
              {openSendAsLinkDialog && (
                <SendasLink
                  openSendAsLinkDialog={openSendAsLinkDialog}
                  setSendAsLinkDialog={setSendAsLinkDialog}
                  setAnchorEl={setAnchorEl}
                  setFileId={setFileId}
                  documentDetails={selectedRowDocumentDetails}
                />
              )}
            </div>
          ) : (
            <div>{<DocumentUpload />}</div>
          )}
        </React.Fragment>
      ) : (
        <div>
          {documentToDisplay && (
            <DocumentViewerComponent
              documentDetails={{ data: [documentToDisplay] }}
              props={props}
              setDataGridComponent={setDataGridComponent}
              isFromViewerVersionHistory={true}
            />
          )}
        </div>
      )}

      {/* -- for Send to TMF Dialog -- */}
      <PopupComponent open={openSend}>
        <Loader open={loaderStatus} />
        <DialogTitle>Send to TMF</DialogTitle>
        <DialogContent className="sendToDialog">
          <DialogContentText>The following documents already exist in TMF:</DialogContentText>
          <Paper sx={{ width: '100%', maxHeight: 242, bgcolor: 'background.paper', overflowY: 'auto' }}>
            <List dense={true}>
              {isfToBePublishedFiles.map((item: any) => {
                return (
                  <ListItem disablePadding key={item.id}>
                    <ListItemButton>
                      <ListItemText primary={item.isf_document_name} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Paper>

          <FormControl>
            <RadioGroup
              aria-labelledby="sent to TMF choice"
              defaultValue=""
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              <FormControlLabel value="newVersion" control={<Radio />} label="Send the document as new version" />
              <FormControlLabel value="overwrite" control={<Radio />} label="Overwrite the document" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleCloseSend} disabled={!checked}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};
